import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import KnowledgeManagementAuthorizer from './components/KnowledgeManagementAuthorizer';

// Lazy load Knowledge Management pages
const ListKnowledgeBasesPage = lazy(() => import('./pages/knowledge-bases/ListKnowledgeBasesPage'));
const AddKnowledgeBasePage = lazy(() => import('./pages/knowledge-bases/AddKnowledgeBasePage'));
const KnowledgeBaseDetailPage = lazy(() => import('./pages/knowledge-bases/KnowledgeBaseDetailPage'));
const EditKnowledgeBasePage = lazy(() => import('./pages/knowledge-bases/EditKnowledgeBasePage'));
const ArticleDetailPage = lazy(() => import('./pages/articles/ArticleDetailPage'));
const CompareArticleVersionsPage = lazy(() => import('./pages/articles/CompareArticleVersionsPage'));
const EditArticlePage = lazy(() => import('./pages/articles/EditArticlePage'));
const AddArticlePage = lazy(() => import('./pages/articles/AddArticlePage'));

export const ROUTES = {
  KNOWLEDGE_BASES: {
    LIST: '/portal/knowledge-management/knowledge-bases',
    ADD: '/portal/knowledge-management/knowledge-bases/add',
    DETAIL: {
      PATH: '/portal/knowledge-management/knowledge-bases/:id',
      buildPath: (id: string) => `/portal/knowledge-management/knowledge-bases/${id}`
    },
    EDIT: {
      PATH: '/portal/knowledge-management/knowledge-bases/:id/edit',
      buildPath: (id: string) => `/portal/knowledge-management/knowledge-bases/${id}/edit`
    }
  },
  ARTICLES: {
    ADD: {
      PATH: '/portal/knowledge-management/knowledge-bases/:kbId/articles/add',
      buildPath: (kbId: string) => `/portal/knowledge-management/knowledge-bases/${kbId}/articles/add`
    },
    DETAIL: {
      PATH: '/portal/knowledge-management/knowledge-bases/:kbId/articles/:articleId',
      buildPath: (kbId: string, articleId: string) =>
        `/portal/knowledge-management/knowledge-bases/${kbId}/articles/${articleId}`
    },
    COMPARE: {
      PATH: '/portal/knowledge-management/knowledge-bases/:kbId/articles/:articleId/compare',
      buildPath: (kbId: string, articleId: string) =>
        `/portal/knowledge-management/knowledge-bases/${kbId}/articles/${articleId}/compare`
    },
    EDIT: {
      PATH: '/portal/knowledge-management/knowledge-bases/:kbId/articles/:articleId/edit',
      buildPath: (kbId: string, articleId: string) =>
        `/portal/knowledge-management/knowledge-bases/${kbId}/articles/${articleId}/edit`
    }
  }
};

const routes: RouteObject[] = [
  {
    element: <KnowledgeManagementAuthorizer />,
    children: [
      {
        path: ROUTES.KNOWLEDGE_BASES.LIST,
        element: <ListKnowledgeBasesPage />
      },
      {
        path: ROUTES.KNOWLEDGE_BASES.ADD,
        element: <AddKnowledgeBasePage />
      },
      {
        path: ROUTES.KNOWLEDGE_BASES.DETAIL.PATH,
        element: <KnowledgeBaseDetailPage />
      },
      {
        path: ROUTES.KNOWLEDGE_BASES.EDIT.PATH,
        element: <EditKnowledgeBasePage />
      },
      {
        path: ROUTES.ARTICLES.ADD.PATH,
        element: <AddArticlePage />
      },
      {
        path: ROUTES.ARTICLES.DETAIL.PATH,
        element: <ArticleDetailPage />
      },
      {
        path: ROUTES.ARTICLES.COMPARE.PATH,
        element: <CompareArticleVersionsPage />
      },
      {
        path: ROUTES.ARTICLES.EDIT.PATH,
        element: <EditArticlePage />
      }
    ]
  }
];

export default routes;
